import { Button } from '@festina-life/ui/actions'
import { Icon, type IconName } from '@festina-life/ui/structure'
import cx from 'classnames'
import type { ComponentProps } from 'react'

type Props = Pick<
  ComponentProps<typeof Button>,
  'onClick' | 'className' | 'tip'
> & {
  iconName: IconName
  iconClassName?: string
}

export const TemplateNavigationButton = ({
  iconName,
  iconClassName,
  className,
  ...restProps
}: Props) => (
  <Button variant="text" className={cx('gap-x-0!', className)} {...restProps}>
    <Icon name={iconName} size="md" className={iconClassName} />
    <Icon name="ArrowDown" />
  </Button>
)
